'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sameValues = function sameValues(x, y) {
  return !(!x || !y) && x === y;
}; /* eslint-disable react/no-find-dom-node */

var UniqueAnimationNamePropType = function UniqueAnimationNamePropType(props) {
  if (sameValues(props.enterAnimation.name, props.leaveAnimation.name)) {
    return new Error('Invalid animation names. ' + 'Animation names for enter & leave must be unique.');
  }
};

var CSSAnimationGroupChild = function (_Component) {
  (0, _inherits3.default)(CSSAnimationGroupChild, _Component);

  function CSSAnimationGroupChild() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CSSAnimationGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CSSAnimationGroupChild.__proto__ || (0, _getPrototypeOf2.default)(CSSAnimationGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.setDisplay = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CSSAnimationGroupChild, [{
    key: 'animate',
    value: function animate(animation, done) {
      var _this2 = this;

      var delay = animation.delay,
          direction = animation.direction,
          duration = animation.duration,
          fillMode = animation.fillMode,
          iterationCount = animation.iterationCount,
          name = animation.name,
          timingFunction = animation.timingFunction;


      var node = (0, _reactDom.findDOMNode)(this);

      /**
       * Bail and immediately invoke done cb if there is no animation defined,
       * there is no node to animate, or browser doesn't support CSS Animation.
       */
      if (!name || !node || !('animationName' in node.style)) {
        done();
        return;
      }

      if (this.removeListener) {
        this.removeListener();
      }

      var start = null;
      /**
       * delay defaults to 0 and is normalized to milliseconds
       * so this will always work
       */
      var timeout = parseInt(delay.match(/\d+/)[0]);
      /**
       * Forcing delay using requestAnimationFrame means that elements that need to swap
       * with one another won't interact in a janky way
       */
      var applyStyles = function applyStyles(timestamp) {
        if (!start) start = timestamp;
        if (timestamp - start >= timeout) {
          node.style.display = '';
          node.style.animationName = name;
          node.style.animationDuration = duration;
          node.style.animationTimingFunction = timingFunction;
          node.style.animationDirection = direction;
          node.style.animationIterationCount = iterationCount;
          node.style.animationFillMode = fillMode;
          node.style.animationPlayState = 'running';
          _this2.setDisplay = true;
          return;
        }
        window.requestAnimationFrame(applyStyles);
      };

      this.delayTimer = window.requestAnimationFrame(applyStyles);

      var handleAnimationEnd = function handleAnimationEnd(event) {
        if (event.animationName === name) {
          removeListener();
          done();
        }
      };
      var removeListener = function removeListener() {
        node.removeEventListener('animationend', handleAnimationEnd);
        delete _this2.removeListener;
      };

      node.addEventListener('animationend', handleAnimationEnd);
      this.removeListener = removeListener;
    }
  }, {
    key: 'changeDisplay',
    value: function changeDisplay() {
      var node = (0, _reactDom.findDOMNode)(this);
      if (node) {
        node.style.display = '';
        this.setDisplay = true;
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      var _props = this.props,
          enterAnimation = _props.enterAnimation,
          enterOnAppear = _props.enterOnAppear,
          children = _props.children;

      var child = _react2.default.Children.only(children);

      if (enterOnAppear && child && child.type && child.type.isNonAnimatedChild !== true) {
        this.animate(enterAnimation, done);
      } else {
        this.changeDisplay();
        done();
      }
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      var _props2 = this.props,
          enterAnimation = _props2.enterAnimation,
          children = _props2.children;

      var child = _react2.default.Children.only(children);
      if (child && child.type && child.type.isNonAnimatedChild !== true) {
        this.animate(enterAnimation, done);
      } else {
        this.changeDisplay();
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      var _props3 = this.props,
          leaveAnimation = _props3.leaveAnimation,
          children = _props3.children;

      var child = _react2.default.Children.only(children);
      if (child && child.type && child.type.isNonAnimatedChild !== true) {
        this.animate(leaveAnimation, done);
      } else {
        this.changeDisplay();
        done();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.removeListener) {
        this.removeListener();
      }
      if (this.delayTimer) {
        window.cancelAnimationFrame(this.delayTimer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          children = _props4.children,
          enterAnimation = _props4.enterAnimation,
          leaveAnimation = _props4.leaveAnimation,
          enterOnAppear = _props4.enterOnAppear,
          restProps = (0, _objectWithoutProperties3.default)(_props4, ['children', 'enterAnimation', 'leaveAnimation', 'enterOnAppear']);


      if (parseInt(enterAnimation.delay.match(/\d+/)[0]) > 0) {
        if (!this.setDisplay) {
          if (restProps.style) {
            restProps.style.display = 'none';
          } else {
            restProps.style = { display: 'none' };
          }
        }
      }

      var child = _react2.default.Children.only(children);
      return child && child.type && child.type.isNonAnimatedChild === true ? child : _react2.default.cloneElement(child, restProps);
    }
  }]);
  return CSSAnimationGroupChild;
}(_react.Component);

process.env.NODE_ENV !== "production" ? CSSAnimationGroupChild.propTypes = {
  enterAnimation: _propTypes2.default.object,
  leaveAnimation: UniqueAnimationNamePropType,
  enterOnAppear: _propTypes2.default.bool,
  children: _propTypes2.default.node
} : void 0;
exports.default = CSSAnimationGroupChild;